import Localization from 'lib/localization';

export default {
    // get lxCookieBannerTitle() {
    //     return Localization.get('bumblesite@team_bumble.page_index.cookie.banner.title');
    // },
    lxCookieBannerText(params: { cookiePolicyLink: string }) {
        let text = Localization.get('settings@cookies.banner.body', params);

        text = text.replace(
            /<a p\d>/,
            `<a style="text-decoration: underline; color: currentColor;" target="_blank" href="${params.cookiePolicyLink}">`
        );

        return text;
    },
    // get lxCookieBannerManageOptions() {
    //     return Localization.get('bumblesite@team_bumble.page_index.cookie.banner.manage_options');
    // },
    // get lxCookieBannerAcceptAll() {
    //     return Localization.get('bumblesite@team_bumble.page_index.cookie.banner.accept_all');
    // },
};
